import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import config from '../../../config'

const CANCEL_REASON = {
  ไม่แนบสลิป: 'ไม่แนบสลิป',
  รูปที่แนบไม่ใช่สลิป: 'รูปที่แนบไม่ใช่สลิป',
  สลิปซ้ำ: 'สลิปซ้ำ',
  ยอดเงินไม่ตรง: 'ยอดเงินไม่ตรง',
  สลิปปลอม: 'สลิปปลอม',
  บัญชีไม่ตรง: 'บัญชีไม่ตรง',
  ไม่สามารถตรวจสอบรายการได้: 'ไม่สามารถตรวจสอบรายการได้',
  ลูกค้ายกเลิก: 'ลูกค้ายกเลิก',
  ปิดงวด: 'ปิดงวด',
  อื่นๆ: 'อื่นๆ',
}

export const deliveryLottery = async (id) => {
  return await Swal.fire({
    icon: 'warning',
    title: 'ยืนยันการจัดส่ง',
    text: 'คุณต้องการยืนยันที่จะจัดส่งออเดอร์นี้ใช่หรือไม่',
    showCancelButton: true,
    showLoaderOnConfirm: true,
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async () => {
      try {
        const headers = new Headers()
        headers.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)
        const { status, data } = await fetch(`${config.apiAdminGateway}/api/v2/admin/payments/delivery`, {
          method: 'POST',
          body: JSON.stringify({ orderNo: id }),
          headers,
        }).then((res) => res.json())

        if (status.code !== 0) throw new Error(status.description)

        return data
      } catch (error) {
        Swal.showValidationMessage(error.message || 'เกิดข้อผิดพลาดในการจัดส่งออเดอร์')
      }
    },
  }).then(async (result) => {
    if (!result.isConfirmed) return false
    return result.value
  })
}

export const cancelPayment = async (id, isForceCancel = false) => {
  return await Swal.fire({
    icon: 'warning',
    title: 'ยืนยันการยกเลิกออเดอร์',
    text: 'คุณต้องการยกเลิกออเดอร์นี้ใช่หรือไม่',
    showCancelButton: true,
    showLoaderOnConfirm: true,
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    input: 'select',
    inputPlaceholder: 'เหตุผลการยกเลิก',
    inputOptions: CANCEL_REASON,
    inputValidator: (value) => {
      if (!value) {
        return 'กรุณาเลือกเหตุผลการยกเลิก'
      }
    },
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async (value) => {
      if (!value) return false

      let reason = value

      if (reason === CANCEL_REASON['อื่นๆ']) {
        reason = await Swal.fire({
          title: 'กรุณากรอกเหตุผลการยกเลิก',
          input: 'text',
          showCancelButton: true,
          inputPlaceholder: 'เหตุผลการยกเลิก',
          inputValidator: (value) => {
            if (!value) {
              return 'กรุณากรอกเหตุผลการยกเลิก'
            }
          },
        }).then((result) => result?.value)
      }

      if (!reason) return false

      try {
        const response = await fetch(`${config.apiAdminGateway}/api/v2/admin/payments/${id}/cancel`, {
          method: 'POST',
          body: JSON.stringify({ reason, forceCancel: isForceCancel }),
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((res) => res.json())

        if (response.status.code !== 0) throw new Error(response.status.description)
      } catch (error) {
        Swal.showValidationMessage(error.message || 'เกิดข้อผิดพลาดในการยกเลิกออเดอร์')
      }
    },
  }).then(async (result) => {
    if (!result.isConfirmed || !result.value) return false

    Swal.fire({
      icon: 'success',
      title: 'ยกเลิกออเดอร์สำเร็จ',
    })

    return true
  })
}

export const approveSlip = async (id, refNumber, amount) => {
  const moneyAmount = Number(amount).toLocaleString()
  return await Swal.fire({
    icon: 'warning',
    title: 'กรุณายืนยันการอนุมัติสลิป',
    html: `
      <div>
        คุณต้องการอนุมัติสลิปนี้ใช่หรือไม่ 
        <br />
        หมายเลขอ้างอิง: <span style="font-weight:600">${refNumber}</span>
        <br /> 
        ยอดเงิน: <span style="font-weight:600">${moneyAmount}</span> บาท
      </div>
    `,
    showCancelButton: true,
    showLoaderOnConfirm: true,
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async () => {
      try {
        const headers = new Headers()
        headers.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)
        const { status } = await fetch(`${config.apiAdminGateway}/api/v2/admin/pop/${id}/approve`, {
          method: 'POST',
          body: JSON.stringify({ tranRef: refNumber, amount }),
          headers,
        }).then((res) => res.json())

        if (status.code !== 0) throw new Error(status.description)
      } catch (error) {
        Swal.showValidationMessage(error.message || 'เกิดข้อผิดพลาดในการอนุมัติสลิป')
      }
    },
  }).then(async (result) => {
    if (!result.isConfirmed) return false

    Swal.fire({
      icon: 'success',
      title: 'อนุมัติสลิปสำเร็จ',
    })

    return true
  })
}

export const rejectSlip = async (id) => {
  return await Swal.fire({
    icon: 'warning',
    title: 'กรุณายืนยันการ Reject slip',
    text: 'เมื่อคุณยืนยันระบบจะอัปเดตสถานะสลิปเป็น REJECT และจะไม่สามารถย้อนกลับได้',
    input: 'checkbox',
    inputValue: 1,
    inputPlaceholder: `
      ส่งการแจ้งเตือนหาลูกค้า
    `,
    showCancelButton: true,
    showLoaderOnConfirm: true,
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async (value) => {
      try {
        const headers = new Headers()
        headers.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)
        const { status } = await fetch(`${config.apiAdminGateway}/api/v2/admin/pop/${id}/reject`, {
          method: 'POST',
          body: JSON.stringify({
            notify: !!value,
          }),
          headers,
        }).then((res) => res.json())

        if (status.code !== 0) throw new Error(status.description)
      } catch (error) {
        Swal.showValidationMessage(error.message || 'เกิดข้อผิดพลาดในการ Reject สลิป')
      }
    },
  }).then(async (result) => {
    if (!result.isConfirmed) return false

    Swal.fire({
      icon: 'success',
      title: 'Reject สลิปสำเร็จ',
    })

    return true
  })
}

export const recheckSlip = async (imageUrl, id, qrText) => {
  return await Swal.fire({
    title: 'ยิงเครื่องสแกน QR Code ที่สลิป',
    text: 'เพื่อดำเนินการตรวจสอบจากเครื่องยิง',
    imageUrl: imageUrl,
    imageAlt: 'Custom image',
    showConfirmButton: false,
    input: 'text',
    inputValue: qrText,
    inputAttributes: {
      autocapitalize: 'on',
    },
    preConfirm: async (qrcode) => {
      try {
        const headers = new Headers()
        headers.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)
        const { status } = await fetch(`${config.apiAdminGateway}/api/v2/admin/pop/${id}/recheck`, {
          method: 'POST',
          body: JSON.stringify({ qrText: qrcode }),
          headers,
        }).then((res) => res.json())

        if (status.code !== 0) throw new Error(status.description)
      } catch (error) {
        Swal.showValidationMessage(error.message || 'เกิดข้อผิดพลาดในการ Recheck สลิป')
      }
    },
  }).then(async (result) => {
    if (!result.isConfirmed) return false

    Swal.fire({
      icon: 'success',
      title: 'Recheck สลิปสำเร็จ',
    })

    return true
  })
}

export const approveWithdraw = async (id) => {
  return await Swal.fire({
    title: 'ยืนยันการอนุมัติ',
    text: 'กรุณากรอกเลขอ้างอิงที่โอนคืนลูกค้า',
    icon: 'warning',
    showCancelButton: true,
    showLoaderOnConfirm: true,
    allowEnterKey: false,
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    input: 'text',
    inputPlaceholder: 'เลขอ้างอิง',
    inputValidator: (value) => {
      if (!value) {
        return 'กรุณากรอกเลขอ้างอิง'
      }
    },
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async (value) => {
      try {
        const response = await fetch(`${config.apiAdminGateway}/api/v2/admin/payments/${id}/withdraw/approve`, {
          method: 'POST',
          body: JSON.stringify({ transRef: value }),
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((res) => res.json())

        if (response.status.code !== 0) throw new Error(response.status.description)
      } catch (error) {
        Swal.showValidationMessage(error.message || 'เกิดข้อผิดพลาดในการอนุมัติการถอนเงิน')
        return false
      }
    },
  }).then(async (result) => {
    if (!result.isConfirmed) return false

    Swal.fire({
      icon: 'success',
      title: 'อนุมัติการถอนเงินสำเร็จ',
    })

    return true
  })
}
